module.exports = __webpack_public_path__ + "img/games-1.4fb89977.jpg";